import React from "react";
import { useIsAuthenticated } from "@azure/msal-react";
import { Route, Routes, Navigate } from "react-router-dom";
import WorkInProgress from "../Modules/Unauthorised/WorkInProgress";
import Welcome from "../Modules/Unauthorised/Welcome";
import Guides from "../Modules/Authorised/Guides";
import ApiReference from "../Modules/Authorised/ApiReference";
import Changelog from "../Modules/Authorised/Changelog";
import Workflow from "../Modules/Authorised/Workflow";
import Profile from "../Modules/Authorised/Profile";
import Settings from "../Modules/Authorised/Settings";
import SupportTicket from "../Modules/Authorised/SupportTicket";
import PrivateRoute from "./PrivateRoute";
import RedirectGuides from "./RedirectGuides";
import ApiSecretKey from "../Modules/Authorised/Profile/ApiSecretKey";
import AuditHistory from "../Modules/Authorised/Profile/AuditHistory";

const AppRoutes = () => {
  const isAuthenticated = useIsAuthenticated();
  console.log('isAuthenticated', isAuthenticated);
  return (
    <Routes>
      <Route
        path="/"
        element={
          isAuthenticated ? <Navigate to="/guides" /> : <Navigate to="/welcome" />
        }
      />
      <Route path="/welcome" element={<Welcome />} />
      <Route element={<PrivateRoute />}>
        <Route path="/guides" element={<RedirectGuides />} />
        <Route path="/guides/:guideId" element={<Guides />} />
        <Route path="/workflows" element={<Workflow />} />
        <Route path="/api-reference" element={<ApiReference />} />
        <Route path="/api-reference/:mainGroupSlug/:subGroupSlug/:apiSlug" element={<ApiReference />} />
        <Route path="/change-logs" element={<Changelog />} />
        <Route path="/profile" element={<Navigate to="/profile/api-secret-details" />} />
        <Route path="/profile" element={<Profile />}>
          <Route path="api-secret-details" element={<ApiSecretKey />} />
          <Route path="secret-key-audit-history" element={<AuditHistory />} />
        </Route>
        <Route path="/settings" element={<Settings />} />
        <Route path="/support-ticket" element={<SupportTicket />} />
      </Route>
      <Route path="*" element={<WorkInProgress />} />
    </Routes>
  );
};
export default AppRoutes;
